<div
    class="hero-carousel__container"
    [class.hero-carousel__container--link]="config[selectedIndex$$()].path"
    (click)="navigateTo(config[selectedIndex$$()].path)"
    (keydown)="({})"
    tabindex="-1"
>
    @for (item of config; track item; let index = $index) {
        <section
            class="hero-carousel__container__section"
            [class.hero-carousel__container__section--fade-in]="
                selectedIndex$$() === index
            "
            [class.hero-carousel__container__section--fade-out]="
                selectedIndex$$() !== index
            "
        >
            <div class="hero-carousel__container__images">
                <img
                    #media
                    [ngSrc]="item.image.path"
                    [attr.alt]="item.image.alt"
                    nwTint
                    [tint]="item.image.tint"
                    [id]="'carousel-image-' + index"
                    height="400"
                    width="600"
                    [priority]="index === 0"
                />
            </div>
            <div class="hero-carousel__container__pages margin-top-l">
                <nw-pill>{{ index + 1 }} / {{ config.length }}</nw-pill>
            </div>
            <div class="hero-carousel__container__content">
                <h5>{{ item.title }}</h5>
                <p>{{ item.content }}</p>
            </div>
        </section>
    }
    <div class="hero-carousel__container__pagination">
        <button
            nw-outline-button
            class="hero-carousel__container__pagination__button"
            (click)="changePage(selectedIndex$$() - 1, $event)"
        >
            <nw-icon
                ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill
                    viewBox="0 0 13 22"
                    height="13px"
                >
                    <path
                        fill="currentColor"
                        d="M.94 9.94a1.502 1.502 0 0 0 0 2.124l9 9a1.502 1.502 0 0 0 2.124-2.123L4.124 11l7.935-7.94A1.502 1.502 0 0 0 9.936.935l-9 9 .004.005Z"
                    />
                </svg>
            </nw-icon>
        </button>
        <button
            nw-outline-button
            class="hero-carousel__container__pagination__button"
            (click)="changePage(selectedIndex$$() + 1, $event)"
        >
            <nw-icon
                ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill
                    viewBox="0 0 13 22"
                    height="13px"
                >
                    <path
                        fill="currentColor"
                        d="M12.06 9.94a1.502 1.502 0 0 1 0 2.124l-9 9a1.502 1.502 0 0 1-2.124-2.123L8.876 11 .942 3.06A1.502 1.502 0 0 1 3.064.935l9 9-.005.005Z"
                    />
                </svg>
            </nw-icon>
        </button>
    </div>
</div>
